(function() {
  if (window.__gamingProductPageV2) {
    return;
  }

  const initProductPage = () => {
    if (window.__gamingProductPageV2) {
      return;
    }
    initLegacyImageGallery();
    initLegacyResolutionSelector();
  };

  const initLegacyImageGallery = () => {
    const thumbnails = document.querySelectorAll('.gaming-product-hero__thumbnail');
    const mainImage = document.querySelector('.gaming-product-hero__image');

    if (!thumbnails.length || !mainImage) {
      return;
    }

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        thumbnails.forEach(thumb => thumb.classList.remove('gaming-product-hero__thumbnail--active'));
        this.classList.add('gaming-product-hero__thumbnail--active');

        const thumbnailImage = this.querySelector('img');
        if (!thumbnailImage) {
          return;
        }

        const newImageSrc = thumbnailImage.src.replace('width=120', 'width=800');

        mainImage.style.opacity = '0.5';
        window.setTimeout(() => {
          mainImage.src = newImageSrc;
          mainImage.style.opacity = '1';
        }, 150);
      });
    });
  };

  const changeMainImageLegacy = imageSrc => {
    const mainImage = document.querySelector('.gaming-product-hero__image');
    if (!mainImage) {
      return;
    }

    mainImage.style.opacity = '0.5';
    window.setTimeout(() => {
      mainImage.src = imageSrc;
      mainImage.style.opacity = '1';
    }, 150);
  };

  const initLegacyResolutionSelector = () => {
    const resolutionButtons = document.querySelectorAll('.gaming-fps-resolution-selector__option');
    const indicator = document.querySelector('.gaming-fps-resolution-selector__indicator');
    const fpsCardsContainer = document.querySelector('.gaming-fps-cards');

    if (!resolutionButtons.length || !indicator || !fpsCardsContainer) {
      return;
    }

    resolutionButtons.forEach((button, index) => {
      button.addEventListener('click', function() {
        resolutionButtons.forEach(btn => btn.classList.remove('gaming-fps-resolution-selector__option--active'));
        this.classList.add('gaming-fps-resolution-selector__option--active');

        indicator.style.transform = `translateX(${index * 100}%)`;

        const selectedResolution = this.getAttribute('data-resolution');
        fpsCardsContainer.setAttribute('data-active-resolution', selectedResolution);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initProductPage);
  window.changeMainImage = changeMainImageLegacy;
})();